<template lang="pug">
div
  y-dialog(v-model="showDialog" fullscreen persistent scrollable content-class="round-3xl")
    v-card.neutral200
      v-card-title.px-8.pt-8
        v-row(no-gutters align="center")
          v-col.shrink
            v-btn.ml-n3(text icon @click="closeDialog" height)
              v-icon(color="basic800" :size="24") mdi-arrow-left
          v-col.ml-3
            .text-2xl.font-semibold.neutral700--text Select preferred time

      v-card-text.pa-8
        v-container.pa-0(:style="`max-width: ${appointmentDetails.frequency ? '800px;' : '700px;'}`")
          v-card.pa-8.round-xl.white(outlined style="border-color: var(--v-neutral300) !important; border-width: 1.5px !important;")
            v-form(ref="form")
              div.d-flex.align-center
                div.text-xl.font-semibold.neutral700--text Set appointment times for the slots below
                v-spacer
                v-card.round-xl.pa-2(v-if="!isLoading && appointmentDetails.frequency" outlined)
                  y-checkbox.mb-n2(v-model="setLaterAll")
                    template(#label)
                      .text-sm.neutral700--text.mt-1 Set later for all
              v-progress-linear.mt-1(v-if="isLoading" :width="3" rounded color="primary" indeterminate)
              template(v-if="!appointmentDetails.frequency")
                div.d-flex.align-center.mt-6
                  div.text-sm.font-semibold Appointment 1
                  v-spacer
                  v-card.round-xl.pa-2(v-if="!isLoading" outlined)
                    y-checkbox.mb-n2(v-model="setLaterAll")
                      template(#label)
                        .text-sm.neutral700--text.mt-1 Set later for all
              template(v-for="(session, idx) in sessions")
                session-item(:session.sync="session" :index="idx" :key="`session-${idx}`" :set-later-all="setLaterAll")

      v-divider
      v-card-actions.py-4(:class="$vuetify.breakpoint.xsOnly ? 'px-4' : 'px-8'")
        v-spacer
        v-btn.button-md(dark color="neutral700" depressed @click="closeDialog") Save & Close
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SessionItem from '@/components/clinic/appointment/advance/SessionItem.vue'

export default {
  components: { SessionItem },
  props: {
    open: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      setLaterAll: false,
      initApptCount: 0,
      sessions: []
    }
  },
  computed: {
    ...mapGetters({ appointmentDetails: 'clinic/getTempAppointmentDetails' }),
    detailsData () {
      return {
        sessions: this.sessions
      }
    },
    showDialog: {
      get () {
        return this.open
      },
      set (val) {
        this.$emit('update:open', val)
      }
    },
    isLoading () {
      if (this.initApptCount !== this.sessions.length) {
        return true
      }
      return false
    }
  },
  mounted () {
    this.setData()
  },
  methods: {
    ...mapActions(['showMessage']),
    setData () {
      if (this.appointmentDetails && this.appointmentDetails.sessions) {
        this.sessions = []
        this.initApptCount = this.appointmentDetails.sessions.length
        let itemsToLoad = this.appointmentDetails.sessions.length
        let items = this.appointmentDetails.sessions
        for (let i = 0; i < itemsToLoad; i++) {
          setTimeout(() => {
            this.sessions.push(items[i])
          }, i * 200)
        }
      }
    },
    closeDialog () {
      if (!this.$refs.form.validate()) {
        let message = this.$t('error_message.please_fill_out_all_required')
        this.showMessage(['error', message])
        return
      }
      this.$store.commit('clinic/updateTempAppointmentDetails', this.detailsData)
      this.showDialog = false
    }
  }
}
</script>

<style lang="scss" scoped>

</style>